import React from "react";
import { fontSizeOptions } from "../../imports";
import { checkForOverride, glow, linearGradient } from "../helpers/theme";
import { ReplaceWithDataSource } from "../helpers/variable";

export default function Score({ cue, baseTheme, baseThemeId, mediaLocation }) {
	const size =
		checkForOverride(baseTheme, "score", cue.preset, "h1", "size") || "sxs";
	const isSize = (element) => element.value === size;
	const gridTemplateSizing = (multiplier = 1, max = null) => {
		let s = fontSizeOptions?.findIndex(isSize) * multiplier;
		if (s <= 1) return 1;
		if (max && s >= max) return max;
		else return s;
	};

	return (
		<>
			<div
				className={`${baseThemeId}_score ${
					baseTheme?.["score"]?.direction === "stacked" ? "" : "flex space-x-2"
				}`}
			>
				{cue.teams &&
					cue.teams.map((t, i) => {
						return (
							<div
								key={i}
								style={{
									fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
									color: checkForOverride(
										baseTheme,
										"score",
										cue.preset,
										"h1",
										"colour"
									),
									fontWeight:
										checkForOverride(
											baseTheme,
											"score",
											cue.preset,
											"h1",
											"bold"
										) === true
											? "bold"
											: "normal",
									fontStyle:
										checkForOverride(
											baseTheme,
											"score",
											cue.preset,
											"h1",
											"italic"
										) === true
											? "italic"
											: "normal",
									textDecoration:
										checkForOverride(
											baseTheme,
											"score",
											cue.preset,
											"h1",
											"underline"
										) === true
											? "underline"
											: "none",
									borderTop: `${
										checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"border",
											"sides"
										)[0] === "1"
											? baseTheme.border.size
											: 0
									}vw ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"style"
									)} ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"colour"
									)}`,
									borderBottom: `${
										checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"border",
											"sides"
										)[1] === "1"
											? baseTheme.border.size
											: 0
									}vw ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"style"
									)} ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"colour"
									)}`,
									borderLeft: `${
										checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"border",
											"sides"
										)[2] === "1"
											? baseTheme.border.size
											: 0
									}vw ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"style"
									)} ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"colour"
									)}`,
									borderRight: `${
										checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											"border",
											"sides"
										)[3] === "1"
											? baseTheme.border.size
											: 0
									}vw ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"style"
									)} ${checkForOverride(
										baseTheme,
										cue.type,
										cue.preset,
										"border",
										"colour"
									)}`,
									gridTemplateColumns: `${
										cue.symbol === "image" ? 4 : 2
									}vw 1fr
									${cue.levels === 0 ? "" : `repeat(${cue.levels}, ${gridTemplateSizing(0.6)}vw)`}
									${
										[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(cue.activeTeam)
											? "4vw"
											: ""
									}`,
									background: linearGradient(
										baseTheme,
										cue.type,
										cue.preset,
										"background",
										"colour"
									),
									boxShadow: glow(
										baseTheme,
										cue.type,
										cue.preset,
										"background",
										"glowBlur"
									),
								}}
								className={`${cue.type} grid 
text-${checkForOverride(baseTheme, "score", cue.preset, "h1", "size")}
rounded-${checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"background",
									"rounding"
								)}
px-${checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"background",
									"paddingX"
								)}
py-${checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"background",
									"paddingY"
								)}
leading-${checkForOverride(baseTheme, "score", cue.preset, "h1", "leading")}
${
	i === cue.teams.length - 2 &&
	baseTheme?.["score"]?.direction === "stacked" &&
	"mb-s1"
}



`}
							>
								{/* <span
                        className="mr-s1"
                        style={{
                            background:
                                cue.flags.single[0].team === i
                                    ? checkForOverride(
                                            baseTheme,
                                            "score",
                                            cue.preset,
                                            "h1",
                                            "colour"
                                      )
                                    : "transparent",
                        }}
                    ></span> */}
								{cue.symbol === "image" ? (
									<img
										className="pr-s2 my-auto"
										alt="Team icon"
										src={`${mediaLocation}${t.image}`}
									/>
								) : (
									<span
										className={`mr-s2
                        
                        rounded-${checkForOverride(
													baseTheme,
													cue.type,
													cue.preset,
													"background",
													"rounding"
												)}
                        `}
										style={{
											backgroundColor: t.colour,
											color: "transparent",
										}}
									>
										{" "}
									</span>
								)}

								<span
									className={`${baseThemeId}_${cue.type}_large_text large_text ${baseThemeId}_col large_text col-span-1 mr-s3 whitespace-pre
                                    
                    `}
								>
									<ReplaceWithDataSource text={t.name} styled={true} />
								</span>
								{cue.scores.map((s, idx) => {
									if (i !== idx) return null;
									return s.map((ss, si) => {
										if (si < cue.levels)
											return (
												<span
													style={{
														textDecoration: "none !important",
														// opacity: `${(s.length - si) * 10 * 2 + 20}%`,
														opacity: `${
															baseTheme?.["score"]?.["odd_opacity"] === false
																? ""
																: si % 2
																? "1"
																: ".7"
														}`,
													}}
													className={`${baseThemeId}_${cue.type}_large_text large_text ${baseThemeId}_justify large_text justify-self-center font-normal not-italic
                                        
                                        `}
												>
													<span className={`${baseThemeId}_${cue.type}_level`}>
														{ss.score}
													</span>{" "}
													{si < cue.levels - 1 ? (
														<span className="absolute pl-s2">
															{cue.delimiter}
														</span>
													) : (
														""
													)}
												</span>
											);
									});
								})}
								{cue.activeTeam === i + 1 && (
									<span className="pl-s1 pr-0">●</span>
								)}
							</div>
						);
					})}
			</div>
		</>
	);
}
